import type { Resolve } from '@angular/router';

import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';

import { AppFacade } from '@web/store/app/app.facade';

@Injectable({
    providedIn: 'root',
})
export class AdminResolver implements Resolve<boolean> {
    private readonly appFacade = inject(AppFacade);

    public resolve(): Observable<boolean> {
        this.appFacade.setIsAdmin(true);
        return of(true);
    }
}
